module.exports = __webpack_public_path__ + "img/0203bee2f37624f61cadcd3553891518.png";